import {z} from "zod";
import {baseFlowFormSchema, NO_VARIANTS_MESSAGE} from "../../flow-form/schema";
import {PAYMENT_METHODS} from "../constants";

const policySchema = z.object({
  methods: z.array(z.enum(PAYMENT_METHODS)),
  default: z.enum(PAYMENT_METHODS),
});

const variantSchema = z
  .object({
    name: z.string(),
    label: z.string(),
    weight: z.number(),
    policy: policySchema,
  })
  .check((ctx) => {
    const {name, policy} = ctx.value;
    if (policy.methods.length === 0) {
      ctx.issues.push({
        code: "custom",
        path: ["policy", "methods"],
        message: `${name}: add at least one payment method`,
        input: policy.methods,
      });
    } else if (!policy.methods.includes(policy.default)) {
      ctx.issues.push({
        code: "custom",
        path: ["policy", "default"],
        message: `${name}: the default method must be one of the shown methods`,
        input: policy.default,
      });
    }
  });

export const formSchema = baseFlowFormSchema.extend({
  variants: z.array(variantSchema).min(1, NO_VARIANTS_MESSAGE),
});

export type FormValues = z.infer<typeof formSchema>;
export type VariantFormValues = FormValues["variants"][number];
